import {
  animate,
  query,
  stagger,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ResourceVm } from 'qp-ui-interface';
import { LanguageService } from 'src/app/language.service';
import {
  ContentDetailInfo,
  ContentDetailService,
} from './content-detail.service';
import { ContentType } from '../../enums/contentType';

@Component({
  selector: 'app-content-detail',
  templateUrl: './content-detail.component.html',
  styleUrls: ['./content-detail.component.scss'],
  animations: [
    trigger('zoomOutStagger', [
      transition(':enter', [
        query(
          '.zoom-in',
          [
            style({ opacity: 0, transform: 'scale(1.05)' }),
            stagger(80, [
              animate(
                '400ms ease-out',
                style({ opacity: 1, transform: 'scale(3)' })
              ),
            ]),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
})
export class ContentDetailComponent implements OnInit {
  @Input() resource: ResourceVm;
  @Input() maxLines: number = 5;
  @Input() showDescription = false;
  titleImage: string;
  title: string;
  trending: number | null = 1;
  contentDetailInfo: ContentDetailInfo;
  @Input() lang = 'en';
  isImageLoaded = false;
  allowedTitleTypes: string[] = [
    ContentType.WEB_EPISODE,
    ContentType.TV_EPISODE,
  ];

  constructor(
    private readonly contentDetailService: ContentDetailService,
    private readonly languageService: LanguageService
  ) {}

  ngOnInit(): void {
    this.lang = this.languageService.currLang;
    this.title = this.resource.title[this.lang];
    this.titleImage = this.contentDetailService.getOptimizedImageUrl(
      this.resource.customTitleImage
    );
    this.contentDetailInfo = this.contentDetailService.getContentDetailInfo(
      this.resource
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    const currValue = changes['resource'].currentValue;
    const prevValue = changes['resource'].previousValue;

    if (currValue) {
      const titleImg = document.getElementById('titleImg') as HTMLImageElement;
      if (
        titleImg &&
        currValue &&
        prevValue &&
        currValue.customTitleImage !== prevValue.customTitleImage
      ) {
        titleImg.src = '';
      }
      this.title = this.resource.title[this.lang];
      this.titleImage = this.contentDetailService.getOptimizedImageUrl(
        this.resource.customTitleImage
      );
      this.contentDetailInfo = this.contentDetailService.getContentDetailInfo(
        this.resource
      );
    }
  }

  get imageWidth() {
    return this.contentDetailService.getComputedImageWidth(this.titleImage);
  }

  /**
   * Handle image load event
   */
  onImageLoad(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    if (imgElement.complete) {
      this.isImageLoaded = true;
    }
  }

  onImageLoadStart(): void {
    this.isImageLoaded = false;
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
}
